export default class MediaLibraryAsset extends Backbone.Model
  urlRoot: "/media/"

  isMediaLibraryAsset: true

  url: ->
    if @get("asset_id")
      @urlRoot + @get("asset_id")
    else
      @urlRoot

  toggleSelected: ->
    @set("selected", !@get("selected"))

  hasThumbnail: ->
    @get("fileType") in [
      "image/jpeg",
      "image/png",
      "image/pjpeg",
      "image/gif",
      "image/x-png",
      "image/bmp"
    ]



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/models/assets/media_library_asset.js.coffee